import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import React, { ReactNode, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../Auth/AuthConfig.tsx";
import useAccessToken from "../Custom/useAccessToken.tsx";

interface AuthenticatedRouteProps {
  children: ReactNode;
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({
  children,
}) => {
  const { accessToken } = useAccessToken();

  const navigate = useNavigate();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!accessToken) return;
    const fetchUserInfo = async () => {
      if (!accessToken || hasFetched.current) return;
      hasFetched.current = true;
    };

    fetchUserInfo();
  }, [accessToken, navigate]);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={apiRequest}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default AuthenticatedRoute;
